var map = {
	"./crayola.json": "3a51",
	"./nippon-orig.json": "a0df",
	"./nippon.json": "d843",
	"./palettes.json": "dd97",
	"./pantone.json": "4632",
	"./spanish.json": "7e94",
	"./werner.json": "3849"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9320";